var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-snackbar', _vm._b({
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "large": "",
            "text": "",
            "icon": "",
            "color": "pink"
          },
          on: {
            "click": function ($event) {
              _vm.shows = false;
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'v-snackbar', _vm.$attrs, false), [_c('v-card-title', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }